import {
    useState,
    useEffect,
    forwardRef,
    useImperativeHandle,
    useRef,
    useCallback,
} from "react";
import {
    ColumnDef,
    ColumnFiltersState,
    SortingState,
    VisibilityState,
    flexRender,
    getCoreRowModel,
    getExpandedRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
} from "@tanstack/react-table";

import {
    SlidersVertical,
    Settings,
    RefreshCcw,
    Search,
    EllipsisVertical
} from "lucide-react";

import { Button, Form, Popconfirm, useCRUDController } from "../../../ui/ot";
import { Checkbox } from "../../../ui/checkbox";
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "../../../ui/dropdown-menu";
import { Input } from "../../../ui/input";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../../../ui/table";
import { Row, Col } from "../../../ui/RowCol";
import { RadioGroup, RadioGroupItem } from "../../../ui/radio-group";
import SearchOt from "./SearchOt";
import PagenationOt from "./PagenationOt";
import dayjs from "dayjs";
import { ModifyModal, useProTableOt, DeleteButton, PatchButton } from "../controllers/ProtableOtController";
import { useNews } from "../../../news/controller/NewsController";
import { Spinner } from "../../../ui/spinner";

import MultipleSelector from "../../../ui/multiple-selector";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useDrag, useDrop } from "react-dnd";
import update from "immutability-helper";
import { useMemo } from "react";
import { Select, message } from '../../../ui/ot'
import InfiniteScroll from "react-infinite-scroll-component";
import { Card as OTCard } from '../../../ui/ot'
import { useTranslation } from "react-i18next";
const ProTableOt = forwardRef(
    (
        {
            columns = [],
            check = [],
            setCheck = () => { },
            request = () => {
                return new Promise((resolve, reject) => {
                    resolve({
                        data: [],
                        total: 0,
                    });
                });
            },
            actionRef = null,
            rowSelection = {
                selectedRowKeys: [],
                type: "checkbox",
                onSelectAll: () => { },
                onSelect: () => { },
                onChange: () => { },
            },
            //欄位排序
            tableAlertRender = () => <></>,
            headerTitle,
            rowKey = "key",
            toolBarRender = () => {
                return [];
            },
            extra_columns = [],
            set_extra_columns,
            manage_columns = true,
            scroll = {
                x: "max-content",
                y: "100%",
            },
            defaultExpandAllRows = false,
            fontSize = "16px", //設定整體字體大小
            pageSize = 10,
            showMode = "page", // page || infiniteScroll || card || cardPage,
            cardRender = () => { },
            cardModeSetting = {
                columnsCount: 5,
                singleRowHeight: 60,
            },
            searchParams,
            search_filter_props_text,
            propsPatchOnBefore = () => { },
            propsPatchonFinish = () => { },
            PropsPatchForm = () => <></>,
            propsOnModalConfirm,
            propsUseData = () => { },
            propsPatch = false,
            propsPatchProcess,
            modalOpen = false,
            setModalOpen = () => { },
            propsDelete = false,
            propsOnlyShowMultipleDelete = false,
            propsDeleteOnBefore = () => { },
            propsDeleteonFinish = () => { },
            propsPost = false,
            propsPostChildren,
            propsPostChildrenKey = [],//新增子項目要從原本record帶入的資訊
            propsPostOnBefore = () => { },
            initialValues,
            propsWidth,
            extraActionRender = () => { },
            propsDeleteModal = false,
            propsChildrenText,
            filterOptions = [],//查詢時資料集，用於SearchOt關鍵字比對過濾
            reloadButton = true,//開關顯示
            manageColumnsButton = true,//開關顯示
            showSearch = true,//是否顯示搜尋框
            propsDefaultAxiosMode,
            readonly = false,
            formMode = false, //讓批次新增、修改、刪除，會自動送propsForm、field、onFormFinish
            isMultipleEdit = true, //是否要開啟多筆新增、修改的功能，因為目前有情況是只需要單筆的 true || false
            prefixRender, //form前面的呈現（新增的上面）
        },
        ref
    ) => {
        const { t } = useTranslation('translation')
        const [sortedColumns, setSortedColumns] = useState([]);
        const [sorting, setSorting] = useState([]);
        const [form] = Form.useForm()
        const [columnFilters, setColumnFilters] = useState([]);
        const [columnVisibility, setColumnVisibility] = useState({});
        const [dataInformations, setDataInformations] = useState({
            data: [],
            total: 0,
        });
        const [pagination, setPagination] = useState({
            pageIndex: 0, //initial page index
            pageSize: pageSize, //default page size
        });
        const [rowCount, setRowCount] = useState(0); //協助計算table 總數量
        const [customFilterValue, setCustomFilterValue] = useState(search_filter_props_text || "");
        useEffect(() => {
            setCustomFilterValue(search_filter_props_text)
        }, [search_filter_props_text])

        const [loading, setLoading] = useState(false);
        const [selectedRowKeys_, setSelectedRowKeys_] = useState(
            rowSelection?.selectedRowKeys || []
        );
        const selectedRowKeys = rowSelection?.selectedRowKeys ?? selectedRowKeys_
        const setSelectedRowKeys = rowSelection?.setSelectedRowKeys ?? setSelectedRowKeys_
        const [selectedRowsInfo_, setSelectedRowsInfo_] = useState(
            rowSelection?.selectedRowsInfo || []
        );
        const selectedRowsInfo = rowSelection?.selectedRowsInfo ?? selectedRowsInfo_
        const setSelectedRowsInfo = rowSelection?.setSelectedRowsInfo ?? setSelectedRowsInfo_

        const [menuOpen, setMenuOpen] = useState(false);
        const [columnShowMenuOpen, setColumnShowMenuOpen] = useState(false);
        const [axiosMode, setAxiosMode] = useState(propsDefaultAxiosMode ?? "get")


        const onTableSearch = ({ params, sort, filter }) => {
            setLoading(true);
            request(params, sort, filter)
                .then((response) => {

                    setDataInformations({
                        data: response?.data || [],
                        total: response?.total || 0,
                    });
                    setRowCount(response?.total || 0);
                    setPagination((pre) => {
                        return {
                            ...pre,
                            pageIndex: 0,
                        };
                    });
                    setLoading(false);
                })
                .catch(function (err) {
                    // Crawling failed...
                    setDataInformations({
                        data: [],
                        total: 0,
                    });
                    setRowCount(0);
                    setPagination((pre) => {
                        return {
                            ...pre,
                            pageIndex: 0,
                        };
                    });
                    setLoading(false);
                });
        };
        const onPageChange = ({ params, sort, filter }) => {
            if (showMode === "page" || showMode === "cardPage") {
                setLoading(true);
            }
            request(params, sort, filter).then((response) => {
                if (showMode === "infiniteScroll" || showMode === "card") {
                    setDataInformations((pre) => {
                        return {
                            data: [...pre.data, ...response?.data],
                            total: response?.total
                        }
                    });
                }
                else {
                    setDataInformations({
                        data: response?.data || [],
                        total: response?.total || 0,
                    });
                }
                setRowCount(response?.total || 0);
                setLoading(false);
            });
        };
        const reload = ({ params, sort, filter }) => {
            setLoading(true);
            request(params, sort, filter)
                .then((response) => {
                    setDataInformations({
                        data: response?.data || [],
                        total: response?.total || 0,
                    });
                    setRowCount(response?.total || 0);
                    setLoading(false);
                })
                .catch(function (err) {
                    // Crawling failed...
                    setDataInformations({
                        data: [],
                        total: 0,
                    });
                    setRowCount(0);
                    setPagination((pre) => {
                        return {
                            ...pre,
                            pageIndex: 0,
                        };
                    });
                    setLoading(false);
                });
        };
        const reloadAndRest = () => {
            setLoading(true);
            request(
                {
                    current: 1,
                    pageSize: pagination?.pageSize,
                    keyword: customFilterValue,
                },
                [],
                {}
            )
                .then((response) => {
                    setCustomFilterValue("");
                    setDataInformations({
                        data: response?.data || [],
                        total: response?.total || 0,
                    });
                    setRowCount(response?.total || 0);
                    setPagination((pre) => {
                        return {
                            ...pre,
                            pageIndex: 0,
                        };
                    });
                    setLoading(false);
                    setPagination((pre) => {
                        return {
                            ...pre,
                            pageIndex: 0,
                        };
                    });
                })
                .catch(function (err) {
                    // Crawling failed...
                    setDataInformations({
                        data: [],
                        total: 0,
                    });
                    setRowCount(0);
                    setPagination((pre) => {
                        return {
                            ...pre,
                            pageIndex: 0,
                        };
                    });
                    setLoading(false);
                });
        };

        const checkAllSearchColumn = () => {
            setCheck((pre) => {
                let newData = columns
                    .filter((column) => !column.disabled)
                    .map((column) => {
                        return column.key;
                    });

                return newData;
            });
        };
        //rowSelection  會用到的 function
        const onOtTableSelect = (record, selected, selectedRows) => {
            rowSelection?.onSelect(record, selected, selectedRows);
        };
        const onOtTableSelectAll = (selected, selectedRows, changeRows) => {
            rowSelection?.onSelectAll(selected, selectedRows, changeRows);
        };
        const onOtTableSelectChange = (selectedRowKeys, selectedRows, info) => {
            rowSelection?.onChange(selectedRowKeys, selectedRows, info);
        };

        //actionRef 可以呼叫的 function
        useImperativeHandle(
            actionRef,
            () => {
                return {
                    reload: () => {
                        if (showMode !== 'infiniteScroll' && showMode !== "card") {
                            reload({
                                params: {
                                    current: pagination?.pageIndex + 1,
                                    pageSize: pagination?.pageSize,
                                    keyword: customFilterValue,
                                },
                                sort: transferSortAntdToShadcn({ sorts: sorting }),
                                filter: {},
                            });
                        }

                    },
                    reloadAndRest: () => {
                        reloadAndRest();
                    },
                };
            },
            [pagination, customFilterValue, sorting, searchParams]
        );

        const { transferColumnAntdToShadcn, transferSortAntdToShadcn } =
            useProTableOt({});
        const [expanded, setExpanded] = useState(defaultExpandAllRows);
        //table setting
        const table = useReactTable({
            data: dataInformations?.data,
            columns: transferColumnAntdToShadcn({
                columns: [...sortedColumns, ...extra_columns],
                currentTableData: dataInformations?.data,
                rowSelectType: rowSelection?.type,
                rowKey: rowKey || "key",
                selectedRowKeys,
                setSelectedRowKeys: setSelectedRowKeys,
                selectedRowsInfo,
                setSelectedRowsInfo: setSelectedRowsInfo,
                onSelect: onOtTableSelect,
                onSelectAll: onOtTableSelectAll,
                onChange: onOtTableSelectChange,
                propsPatchOnBefore,
                propsPatchonFinish,
                PropsPatchForm,
                propsOnModalConfirm,
                propsUseData,
                propsPatch,
                propsPatchProcess,
                modalOpen,
                setModalOpen,
                propsForm: form,
                propsPost,
                propsPostChildren,
                propsPostChildrenKey,
                propsPostOnBefore,
                propsDelete,
                axiosMode,
                setAxiosMode,
                extraActionRender,
                propsDeleteModal,
                propsChildrenText,
                initialValues,
                readonly,
            }),
            onExpandedChange: setExpanded,
            getSubRows: (row) => row.children,
            onSortingChange: (value) => {
                setSorting(value)
            },
            onColumnFiltersChange: setColumnFilters,
            getCoreRowModel: getCoreRowModel(),
            manualPagination: true,
            rowCount,
            onPaginationChange: setPagination,
            getPaginationRowModel: getPaginationRowModel(),
            getSortedRowModel: getSortedRowModel(),
            getFilteredRowModel: getFilteredRowModel(),
            onColumnVisibilityChange: setColumnVisibility,
            getExpandedRowModel: getExpandedRowModel(),
            state: {
                sorting,
                columnFilters,
                columnVisibility,
                pagination,
                expanded,
            },
        });
        useEffect(() => {
            // reload({
            //     params: {
            //         current: pagination?.pageIndex + 1,
            //         pageSize: pagination?.pageSize,
            //         keyword: customFilterValue,
            //     },
            //     sort: transferSortAntdToShadcn({ sorts: sorting }),
            //     filter: {},
            // });
            checkAllSearchColumn();
            if (propsDefaultAxiosMode === "post") {
                form.setFieldsValue({ recordset: [{}] })
            }
        }, []);
        useEffect(() => {
            reload({
                params: {
                    current: pagination?.pageIndex + 1,
                    pageSize: pagination?.pageSize,
                    keyword: customFilterValue,
                },
                sort: transferSortAntdToShadcn({ sorts: sorting }),
                filter: {},
            });
        }, [sorting]);


        const moveCard = useCallback((dragIndex, hoverIndex) => {
            setSortedColumns((prev) => {
                let settings = {}
                let new_update = update(prev, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, prev[dragIndex]],
                    ],
                })
                new_update.forEach((element, index) => {
                    settings[element?.key] = { order: index }
                })

                let storedSettings = JSON.parse(localStorage.getItem(`ot-table-setting`)) || {};
                storedSettings = JSON.stringify({
                    ...Object.entries(settings).reduce((all, [key, value]) => {
                        return {
                            ...all,
                            [key]: {
                                ...storedSettings[key],
                                ...settings[key]
                            }
                        }
                    }, {}
                    ),
                    // [column?.id]: {
                    //     ...storedSettings?.[column?.id],
                    //     ...settings?.[column?.id],
                    // }
                })
                localStorage.setItem(`ot-table-setting`, storedSettings);

                postCustomPageSetting([{
                    page_name: window.location.pathname,
                    custom_setting: storedSettings
                }])
                return update(prev, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, prev[dragIndex]],
                    ],
                });
            });
        }, []);

        const renderCard = useCallback((column, index) => {
            return (
                <Card
                    key={index}
                    column={column}
                    index={index}
                    moveCard={(dragIndex) => moveCard(dragIndex, index)}
                />
            );
        }, []);

        const onCleanSelected = () => {
            setSelectedRowKeys([]);
            rowSelection.onSelectAll(false, [], selectedRowKeys);
            setSelectedRowsInfo([]);
        };

        function IndeterminateCheckbox({
            indeterminate,
            className = "",
            ...rest
        }) {
            const ref = useRef(null);

            useEffect(() => {
                if (typeof indeterminate === "boolean") {
                    ref.current.indeterminate = !rest.checked && indeterminate;
                }
            }, [ref, indeterminate]);

            return (
                <input
                    type="checkbox"
                    ref={ref}
                    className={className + " cursor-pointer"}
                    {...rest}
                />
            );
        }
        const getDefaultColumns = (setting, columns) => {
            let newSettingColumns = columns.sort((a, b) => {
                const orderA = setting[a.key]?.order ?? Infinity;
                const orderB = setting[b.key]?.order ?? Infinity;
                return orderA - orderB;
            })
            return newSettingColumns
        }




        const { getData: getCustomPageSetting, postData: postCustomPageSetting, ResponseData: customPageSettingData } = useCRUDController({
            apiRoute: '/utility/custom_page_setting'
        })


        // 蒐集各個Header的客製化查詢
        const [customHeaderFilter, setCustomHeaderFilter] = useState([]);
        const [customHeaderFilterStateArray, setCustomHeaderFilterStateArray] = useState({});

        // 監聽 Custom Header Filter 的事件
        const onCustomHeaderFilterChange = ({ params, sort, filter }) => {
            setCustomHeaderFilter((item) => {
                return ({
                    ...item,
                    [filter?.id]: filter.value
                })
            })
        }

        useEffect(() => {
            // setLoading(true);
            request({
                current: 1,
                pageSize: pagination?.pageSize,
                keyword: customFilterValue,
            }, transferSortAntdToShadcn({
                sorts: sorting,
            }), customHeaderFilter)
                .then((response) => {
                    setDataInformations({
                        data: response?.data || [],
                        total: response?.total || 0,
                    });
                    setRowCount(response?.total || 0);
                    setPagination((pre) => {
                        return {
                            ...pre,
                            pageIndex: 0,
                        };
                    });
                    // setLoading(false);
                })
                .catch(function (err) {
                    // Crawling failed...
                    setDataInformations({
                        data: [],
                        total: 0,
                    });
                    setRowCount(0);
                    setPagination((pre) => {
                        return {
                            ...pre,
                            pageIndex: 0,
                        };
                    });
                    // setLoading(false);
                });
        }, [customHeaderFilter])

        useEffect(() => {
        }, [customHeaderFilterStateArray])


        useEffect(() => {
            if (customPageSettingData?.find(_ => true)?.custom_setting) {
                localStorage.setItem(`ot-table-setting`, JSON.stringify(customPageSettingData?.find(_ => true)?.custom_setting));
                table
                    .getAllColumns()
                    .filter((column) =>
                        column.getCanHide()
                    )
                    .forEach((column, index) => {
                        if (customPageSettingData?.find(_ => true)?.custom_setting?.[column?.id]?.show === false) {
                            column.toggleVisibility(false)
                        }
                    })
            }
            const storedSettings = JSON.parse(localStorage.getItem(`ot-table-setting`)) || {};
            let defaultColumns = getDefaultColumns(storedSettings, columns)
            setSortedColumns(defaultColumns);

            // 各個Header的客製化查詢的State初始化
            setCustomHeaderFilterStateArray(item => columns
                .filter((column) => column?.canFilter === true) // 過濾出有 canFilter 為 true 的列
                .reduce((acc, column) => {
                    return {
                        ...acc,
                        [column?.key]: {
                            key: column?.key,
                            modalOpen: false,
                            filterType: column?.filterType,
                            textValue: item?.[column?.key]?.textValue || "",
                            selectValue: item?.[column?.key]?.selectValue || [],
                        }
                    }
                }, item)
            )
        }, [columns, customPageSettingData]);

        useEffect(() => {
            getCustomPageSetting({
                page_name: window.location.pathname
            })
        }, [window.location.pathname])
        return (
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <Row justify={'space-between'}>
                        <Col span={24}>
                            <Row justify={"end"}>
                                {showSearch && <Col>
                                    <SearchOt
                                        options={filterOptions}
                                        extraIconButton={() => {
                                            return (
                                                <DropdownMenu
                                                    modal={false}
                                                    open={columnShowMenuOpen}
                                                >
                                                    <DropdownMenuTrigger asChild>
                                                        <div className="absolute right-6 top-1/2 transform -translate-y-1/2">
                                                            <SlidersVertical
                                                                onClick={() => {
                                                                    setColumnShowMenuOpen(true)
                                                                }}
                                                                size={18}
                                                                style={{
                                                                    cursor: "pointer",
                                                                }}
                                                            />
                                                        </div>
                                                    </DropdownMenuTrigger>
                                                    <DropdownMenuContent
                                                        style={{
                                                            maxHeight: "50vh",
                                                            overflowY: "scroll",
                                                        }}
                                                        onPointerDownOutside={() => {
                                                            setColumnShowMenuOpen(false)
                                                        }}
                                                        align="end">
                                                        <DropdownMenuLabel>
                                                            選擇欲搜尋欄位
                                                        </DropdownMenuLabel>
                                                        {table
                                                            .getAllColumns()
                                                            .filter(
                                                                (column) =>
                                                                    !column.columnDef
                                                                        .disabled
                                                            )
                                                            .map((column) => {
                                                                return (
                                                                    <DropdownMenuCheckboxItem
                                                                        key={column.id}
                                                                        className="capitalize"
                                                                        checked={check.includes(
                                                                            column.id
                                                                        )}
                                                                        onCheckedChange={(
                                                                            value
                                                                        ) => {
                                                                            if (
                                                                                column.id
                                                                            ) {
                                                                                if (
                                                                                    value
                                                                                ) {
                                                                                    setCheck(
                                                                                        (
                                                                                            pre
                                                                                        ) => {
                                                                                            return [
                                                                                                ...pre,
                                                                                                column.id,
                                                                                            ];
                                                                                        }
                                                                                    );
                                                                                } else {
                                                                                    setCheck(
                                                                                        (
                                                                                            pre
                                                                                        ) => {
                                                                                            let temp =
                                                                                                [
                                                                                                    ...pre,
                                                                                                ];
                                                                                            let newData =
                                                                                                temp.filter(
                                                                                                    (
                                                                                                        ele
                                                                                                    ) =>
                                                                                                        ele !==
                                                                                                        column.id
                                                                                                );
                                                                                            return newData;
                                                                                        }
                                                                                    );
                                                                                }
                                                                            }
                                                                        }}
                                                                    >
                                                                        {
                                                                            column
                                                                                .columnDef
                                                                                .title
                                                                        }
                                                                    </DropdownMenuCheckboxItem>
                                                                );
                                                            })}
                                                    </DropdownMenuContent>
                                                </DropdownMenu>
                                            );
                                        }}
                                        placeholder={customFilterValue}
                                        value={customFilterValue}
                                        onChange={(value) => {
                                            setCustomFilterValue((pre) => value);
                                        }}
                                        onSearch={(value) => {
                                            onTableSearch({
                                                params: {
                                                    current: 1,
                                                    pageSize: pagination?.pageSize,
                                                    keyword: value,
                                                },
                                                sort: transferSortAntdToShadcn({
                                                    sorts: sorting,
                                                }),
                                                filter: {},
                                            });
                                        }}
                                    />
                                </Col>}
                                {reloadButton &&

                                    <Col>
                                        <Button
                                            variant="ghost"
                                            size="icon"
                                            onClick={() => {
                                                if (showMode !== 'infiniteScroll' && showMode !== "card") {
                                                    reload({
                                                        params: {
                                                            current: pagination?.pageIndex + 1,
                                                            pageSize: pagination?.pageSize,
                                                            keyword: customFilterValue,
                                                        },
                                                        sort: transferSortAntdToShadcn({
                                                            sorts: sorting,
                                                        }),
                                                        filter: {},
                                                    });
                                                }
                                                else if (showMode === 'infiniteScroll' || showMode === "card") {
                                                    reloadAndRest()
                                                }
                                            }}
                                        >
                                            <RefreshCcw />
                                        </Button>
                                    </Col>
                                }
                                {
                                    !readonly && manageColumnsButton &&
                                    <Col>
                                        <DropdownMenu
                                            modal={false}
                                            open={menuOpen}
                                            onOpenChange={(e) => {
                                                // console.log(e);
                                            }}
                                        >
                                            <DropdownMenuTrigger >
                                                <Button
                                                    variant="ghost"
                                                    size="icon"
                                                    onClick={() => {
                                                        setMenuOpen(true);
                                                    }}
                                                >
                                                    <Settings />
                                                </Button>
                                            </DropdownMenuTrigger>
                                            <DropdownMenuContent
                                                style={{
                                                    maxHeight: "50vh",
                                                    overflowY: "scroll",
                                                }}
                                                onPointerDownOutside={() => {
                                                    setMenuOpen(false);
                                                }}
                                                align="end"
                                            >
                                                <DropdownMenuLabel>
                                                    {manage_columns && (
                                                        <Col>
                                                            <Manage_columns
                                                                extra_columns={
                                                                    extra_columns
                                                                }
                                                                onChange={(e) => {
                                                                    set_extra_columns(
                                                                        e.map(
                                                                            (map_item) => {
                                                                                return {
                                                                                    title: map_item?.label,
                                                                                    dataIndex:
                                                                                        map_item?.value,
                                                                                    key: map_item?.value,
                                                                                    label: map_item?.label,
                                                                                    value: map_item?.value,

                                                                                    // render: (_, record) => record.number * record.comments
                                                                                };
                                                                            }
                                                                        )
                                                                    );
                                                                }}
                                                            />
                                                        </Col>
                                                    )}
                                                </DropdownMenuLabel>
                                                <DndProvider backend={HTML5Backend}>
                                                    {table
                                                        .getAllColumns()
                                                        .filter((column) =>
                                                            column.getCanHide()
                                                        )
                                                        .map((column, index) => {
                                                            return renderCard(
                                                                column,
                                                                index,
                                                                columns
                                                            );
                                                        })}
                                                </DndProvider>
                                            </DropdownMenuContent>
                                        </DropdownMenu>
                                    </Col>
                                }
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Row justify={"space-between"} style={{ display: 'contents' }}>
                        {headerTitle && <Col>{headerTitle}</Col>}
                        <Col>
                            {selectedRowKeys?.length > 0 && <span>
                                已選擇 {selectedRowKeys.length} 項
                                <Button
                                    type={'text'}
                                    style={{ marginInlineStart: 8 }}
                                    onClick={onCleanSelected}
                                >
                                    取消選擇
                                </Button>
                            </span>}
                        </Col>
                        <Col>
                            <ModifyModal
                                axiosMode={axiosMode}
                                propsForm={form}
                                propsPatchOnBefore={propsPatchOnBefore}
                                propsPatchonFinish={propsPatchonFinish}
                                PropsPatchForm={PropsPatchForm}
                                propsOnModalConfirm={propsOnModalConfirm}
                                propsUseData={propsUseData}
                                modalOpen={modalOpen}
                                setModalOpen={setModalOpen}
                                propsWidth={propsWidth}
                                initialValues={initialValues}
                                propsDefaultAxiosMode={propsDefaultAxiosMode}
                                formMode={formMode}
                                isMultipleEdit={isMultipleEdit}
                                prefixRender={prefixRender}
                            />
                            <Row gutter={[8, 8]} style={{ alignItems: 'center', justifyContent: 'end' }}>
                                {[...toolBarRender(),
                                ...(!readonly && propsPost ? [
                                    <Button
                                        style={{
                                            backgroundColor: '#C8E6C9',
                                            color: '#388E3C'
                                        }}
                                        onClick={() => {
                                            setModalOpen(true);
                                            setAxiosMode("post")
                                            form.resetFields()
                                            form.setFieldsValue({ 'recordset': [{ ...initialValues }] })
                                            propsPostOnBefore()
                                        }}>{t('multiple')}{t('post')}</Button>,
                                ] : []),
                                ...(isMultipleEdit && !readonly && propsPatch && selectedRowsInfo.length > 0 ? [
                                    <Button
                                        style={{
                                            backgroundColor: '#BBDEFB',
                                            color: '#1976D2'
                                        }}
                                        onClick={() => {
                                            setModalOpen(true);
                                            setAxiosMode("patch")
                                            form.resetFields()
                                            let formValues = selectedRowsInfo
                                            if (propsPatchProcess) {
                                                formValues = formValues?.map(item => propsPatchProcess(item))
                                            }

                                            form.setFieldsValue({ 'recordset': formValues })
                                        }}>{t('multiple')}{t('patch')}</Button>,
                                ] : []),
                                ...(!readonly && (propsOnlyShowMultipleDelete || propsDelete) && selectedRowsInfo.length > 0 ? [
                                    <DeleteButton
                                        propsDeleteModal={propsDeleteModal}
                                        multiple={true}
                                        onConfirm={() => {
                                            if (selectedRowsInfo.length === 0) {
                                                message.info(t('please_select_item'))
                                            }
                                            else {
                                                let deleteDatas = selectedRowsInfo.map((value) => {
                                                    return {
                                                        // [rowKey]: value,
                                                        ...value
                                                    }
                                                })
                                                const { deleteData } = (propsUseData && propsUseData({})) || { deleteData: () => { } };
                                                deleteData(deleteDatas)
                                            }
                                        }}
                                    />

                                ] : [])
                                ].map((ele) => {
                                    return <Col>{ele}</Col>;
                                })}
                            </Row>
                        </Col>
                    </Row>
                </Col>
                {showMode === "page" && <Col span={24}>
                    <Row wrap>
                        <Col span={24}>
                            {loading ? (
                                <Row>
                                    <Col span={24}>
                                        <Spinner>資料讀取中 請稍候...</Spinner>
                                    </Col>
                                </Row>
                            ) : (
                                <div
                                    className="table-container"
                                    // className="p-2 block max-w-full overflow-x-scroll overflow-y-hidden"
                                    style={{
                                        width: "100%", // 表格寬度佔滿可用空間
                                        overflowX: scroll?.x
                                            ? "auto"
                                            : "hidden", // 根據 scroll.x 決定是否啟動水平滾動
                                        overflowY: scroll?.y
                                            ? "auto"
                                            : "hidden", // 根據 scroll.y 決定是否啟動垂直滾動
                                        maxHeight: scroll?.y || "auto", // 如果指定了垂直滾動高度，則設置最大高度
                                        maxWidth: "100%",
                                    }}
                                >
                                    <Table className="w-full ">
                                        <TableHeader>
                                            {table
                                                .getHeaderGroups()
                                                .map((headerGroup) => (
                                                    <TableRow
                                                        key={headerGroup.id}
                                                    >
                                                        {headerGroup.headers.map(
                                                            (header) => {
                                                                let headerKey = header.column.columnDef?.key
                                                                return (
                                                                    <TableHead
                                                                        style={{
                                                                            padding: 4,
                                                                            position: "relative",
                                                                            width: header.getSize() + 18,
                                                                            fontSize: fontSize || "1rm",
                                                                            fontWeight: 'bolder',
                                                                            color: "#000"
                                                                        }}
                                                                        key={
                                                                            header.id
                                                                        }
                                                                    >
                                                                        <Col span={24}>
                                                                            {header.isPlaceholder
                                                                                ? null
                                                                                : <Row align="middle" justify="end" >
                                                                                    <Col  span={22}  >
                                                                                        {flexRender(
                                                                                            header
                                                                                                .column
                                                                                                .columnDef
                                                                                                .header,
                                                                                            header.getContext()
                                                                                        )}
                                                                                    </Col>
                                                                                    <Col   >
                                                                                        {header.column.columnDef?.canFilter ? (<>
                                                                                            {header.column.columnDef?.filterType === "search" ?
                                                                                                <>
                                                                                                    <DropdownMenu
                                                                                                        modal={false}
                                                                                                        open={customHeaderFilterStateArray?.[headerKey]?.modalOpen}
                                                                                                    >
                                                                                                        <DropdownMenuTrigger asChild>
                                                                                                            <div className=" ">
                                                                                                                <Search
                                                                                                                    onClick={() => {
                                                                                                                        setCustomHeaderFilterStateArray((item) => {
                                                                                                                            return {
                                                                                                                                ...item,
                                                                                                                                [headerKey]: {
                                                                                                                                    key: headerKey,
                                                                                                                                    modalOpen: true,
                                                                                                                                    filterType: item?.[headerKey]?.filterType,
                                                                                                                                    textValue: item?.[headerKey]?.textValue,
                                                                                                                                    selectValue: item?.[headerKey]?.selectValue,
                                                                                                                                }
                                                                                                                            }
                                                                                                                        })
                                                                                                                    }}
                                                                                                                    size={18}
                                                                                                                    style={{ cursor: "pointer", }}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </DropdownMenuTrigger>
                                                                                                        <DropdownMenuContent
                                                                                                            style={{
                                                                                                                maxHeight: "50vh",
                                                                                                                overflowY: "scroll",
                                                                                                            }}
                                                                                                            onPointerDownOutside={() => {
                                                                                                                setCustomHeaderFilterStateArray((item) => {
                                                                                                                    return {
                                                                                                                        ...item,
                                                                                                                        [headerKey]: {
                                                                                                                            key: headerKey,
                                                                                                                            modalOpen: false,
                                                                                                                            filterType: item?.[headerKey]?.filterType,
                                                                                                                            textValue: item?.[headerKey]?.textValue,
                                                                                                                            selectValue: item?.[headerKey]?.selectValue,
                                                                                                                        }
                                                                                                                    }
                                                                                                                })
                                                                                                            }}
                                                                                                            align="end">
                                                                                                            <DropdownMenuLabel>{flexRender(header.column.columnDef.header, header.getContext())}</DropdownMenuLabel>
                                                                                                            <Input
                                                                                                                column={header.column}
                                                                                                                value={customHeaderFilterStateArray?.[headerKey]?.textValue}
                                                                                                                onChange={(e) => {
                                                                                                                    setCustomHeaderFilterStateArray((item) => {
                                                                                                                        return {
                                                                                                                            ...item,
                                                                                                                            [headerKey]: {
                                                                                                                                key: headerKey,
                                                                                                                                modalOpen: item?.[headerKey]?.modalOpen,
                                                                                                                                filterType: item?.[headerKey]?.filterType,
                                                                                                                                textValue: e.target.value,
                                                                                                                                selectValue: item?.[headerKey]?.selectValue,
                                                                                                                            }
                                                                                                                        }
                                                                                                                    })
                                                                                                                    onCustomHeaderFilterChange({
                                                                                                                        params: {
                                                                                                                            current: 1,
                                                                                                                            pageSize: pagination?.pageSize,
                                                                                                                            keyword: customFilterValue,
                                                                                                                        },
                                                                                                                        sort: transferSortAntdToShadcn({
                                                                                                                            sorts: sorting,
                                                                                                                        }),
                                                                                                                        filter: {
                                                                                                                            value: e.target.value,
                                                                                                                            id: header.column.id,
                                                                                                                            type: "text"
                                                                                                                        },
                                                                                                                    })
                                                                                                                }}
                                                                                                            />
                                                                                                        </DropdownMenuContent>
                                                                                                    </DropdownMenu>
                                                                                                </>
                                                                                                : <></>}
                                                                                            {header.column.columnDef?.filterType === "select" ? <></> : <></>}
                                                                                        </>) : null}
                                                                                    </Col>
                                                                                </Row>
                                                                            }
                                                                        </Col>
                                                                    </TableHead>
                                                                );
                                                            }
                                                        )}
                                                    </TableRow>
                                                ))}
                                        </TableHeader>
                                        <TableBody>
                                            {table.getRowModel().rows
                                                ?.length ? (
                                                table
                                                    .getRowModel()
                                                    .rows.map((row) => (
                                                        <TableRow
                                                            key={row.id}
                                                            data-state={
                                                                row.getIsSelected() &&
                                                                "selected"
                                                            }
                                                        >
                                                            {row
                                                                .getVisibleCells()
                                                                .map((cell) => (
                                                                    <TableCell
                                                                        style={{
                                                                            fontSize:
                                                                                fontSize ||
                                                                                "16px",
                                                                            width: cell.column.getSize(),
                                                                            padding:
                                                                                "8px",
                                                                            whiteSpace:
                                                                                scroll?.x ===
                                                                                    "max-content"
                                                                                    ? "nowrap"
                                                                                    : "inherit",
                                                                        }}
                                                                        key={
                                                                            cell.id
                                                                        }
                                                                    >
                                                                        {flexRender(
                                                                            cell
                                                                                .column
                                                                                .columnDef
                                                                                .cell,
                                                                            cell.getContext()
                                                                        )}
                                                                    </TableCell>
                                                                ))}
                                                        </TableRow>
                                                    ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell
                                                        colSpan={columns.length}
                                                        className="h-24 text-center"
                                                    >
                                                        沒有資料
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </div>
                            )}
                        </Col>
                        <Col span={24}>
                            <Row
                                gutter={[4, 4]}
                                align={"middle"}
                                justify={"end"}
                            >
                                <Col>
                                    第{" "}
                                    {pagination.pageIndex *
                                        pagination.pageSize +
                                        1}
                                    ~
                                    {(pagination.pageIndex + 1) *
                                        pagination.pageSize <=
                                        rowCount
                                        ? (pagination.pageIndex + 1) *
                                        pagination.pageSize
                                        : rowCount}{" "}
                                    筆 / 總共 {rowCount} 筆
                                </Col>
                                <Col>
                                    <Row gutter={[2, 2]} align={"middle"} wrap={false}>
                                        <Col>每頁</Col>
                                        <Col>
                                            <Select
                                                defaultValue={{
                                                    label: `${pagination?.pageSize}`,
                                                    value: pagination?.pageSize
                                                }}
                                                value={{
                                                    label: pagination?.pageSize,
                                                    value: pagination?.pageSize
                                                }}
                                                options={[
                                                    {
                                                        label: '10',
                                                        value: 10
                                                    },
                                                    {
                                                        label: '20',
                                                        value: 20
                                                    },
                                                    {
                                                        label: '30',
                                                        value: 30
                                                    },
                                                    {
                                                        label: '50',
                                                        value: 50
                                                    },
                                                    {
                                                        label: '100',
                                                        value: 100
                                                    },

                                                ]}
                                                onChange={(value) => {
                                                    table.setPageIndex(0);
                                                    onPageChange({
                                                        params: {
                                                            current: 1,
                                                            pageSize:
                                                                value,
                                                            keyword: customFilterValue,
                                                        },
                                                        sort: transferSortAntdToShadcn({
                                                            sorts: sorting,
                                                        }),
                                                        filter: {},
                                                    });
                                                    setPagination((pre) => {
                                                        return {
                                                            ...pre,
                                                            pageIndex: 0,
                                                            pageSize: value
                                                        }
                                                    })
                                                }}
                                            /></Col>
                                        <Col>筆</Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <PagenationOt
                                        pageIndex={pagination?.pageIndex}
                                        pageCount={table.getPageCount()}
                                        onChange={(currentIndex) => {
                                            table.setPageIndex(currentIndex);
                                            onPageChange({
                                                params: {
                                                    current: currentIndex + 1,
                                                    pageSize:
                                                        pagination?.pageSize,
                                                    keyword: customFilterValue,
                                                },
                                                sort: transferSortAntdToShadcn({
                                                    sorts: sorting,
                                                }),
                                                filter: {},
                                            });
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>}
                {showMode === "infiniteScroll" && <Col
                    span={24}
                // id="scrollableDiv"
                // style={{ height: `${(pagination?.pageSize + 3) * 48}px`, overflow: "auto" }}
                >
                    {loading ? (
                        <Row>
                            <Col span={24}>
                                <Spinner>資料讀取中 請稍候...</Spinner>
                            </Col>
                        </Row>
                    ) : (
                        <InfiniteScroll
                            // scrollableTarget="scrollableDiv"
                            height={scroll?.y === "auto" || scroll?.y === "100%" ? "" : scroll?.y}
                            dataLength={dataInformations?.data?.length}
                            next={() => {
                                table.setPageIndex(pagination?.pageIndex + 1);
                                onPageChange({
                                    params: {
                                        current: pagination?.pageIndex + 2,
                                        pageSize: pagination?.pageSize,
                                        keyword: customFilterValue,
                                    },
                                    sort: transferSortAntdToShadcn({
                                        sorts: sorting,
                                    }),
                                    filter: {},
                                });
                                setPagination((pre) => {
                                    return {
                                        ...pre,
                                        pageIndex: pagination?.pageIndex + 1,
                                    }
                                })
                            }}
                            hasMore={dataInformations?.data?.length < dataInformations?.total}
                            loader={<h4> <Spinner>資料讀取中 請稍候...</Spinner></h4>}
                            endMessage={
                                <p style={{ textAlign: "center" }}>
                                    <b>已經沒有資料了</b>
                                </p>
                            }
                        >

                            <div
                                className="table-container"
                            >
                                <Table className="w-full ">
                                    <TableHeader>
                                        {table
                                            .getHeaderGroups()
                                            .map((headerGroup) => (
                                                <TableRow
                                                    key={headerGroup.id}
                                                >
                                                    {headerGroup.headers.map(
                                                        (header) => {
                                                            return (
                                                                <TableHead
                                                                    style={{
                                                                        padding: 8,
                                                                        position:
                                                                            "relative",
                                                                        width: header.getSize(),
                                                                        fontSize:
                                                                            fontSize ||
                                                                            "16px",
                                                                    }}
                                                                    key={
                                                                        header.id
                                                                    }
                                                                >
                                                                    {header.isPlaceholder
                                                                        ? null
                                                                        : flexRender(
                                                                            header
                                                                                .column
                                                                                .columnDef
                                                                                .header,
                                                                            header.getContext()
                                                                        )}
                                                                </TableHead>
                                                            );
                                                        }
                                                    )}
                                                </TableRow>
                                            ))}
                                    </TableHeader>
                                    <TableBody>
                                        {table.getRowModel().rows?.length ? (
                                            table
                                                .getRowModel()
                                                .rows.map((row) => (
                                                    <TableRow
                                                        key={row.id}
                                                        data-state={
                                                            row.getIsSelected() &&
                                                            "selected"
                                                        }
                                                    >
                                                        {row
                                                            .getVisibleCells()
                                                            .map((cell) => (
                                                                <TableCell
                                                                    style={{
                                                                        fontSize:
                                                                            fontSize ||
                                                                            "16px",
                                                                        width: cell.column.getSize(),
                                                                        padding:
                                                                            "8px",
                                                                        whiteSpace:
                                                                            scroll?.x ===
                                                                                "max-content"
                                                                                ? "nowrap"
                                                                                : "inherit",
                                                                    }}
                                                                    key={
                                                                        cell.id
                                                                    }
                                                                >
                                                                    {flexRender(
                                                                        cell
                                                                            .column
                                                                            .columnDef
                                                                            .cell,
                                                                        cell.getContext()
                                                                    )}
                                                                </TableCell>
                                                            ))}
                                                    </TableRow>
                                                ))
                                        ) : (
                                            <TableRow>
                                                <TableCell
                                                    colSpan={columns.length}
                                                    className="h-24 text-center"
                                                >
                                                    沒有資料
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </div>

                        </InfiniteScroll>
                    )}
                </Col>}
                {showMode === "card" && <Col
                    span={24}
                    // id="scrollableCard"
                    style={{
                        overflow: "auto"
                    }}
                >
                    {loading ? (
                        <Row>
                            <Col span={24}>
                                <Spinner>資料讀取中 請稍候...</Spinner>
                            </Col>
                        </Row>
                    ) : (
                        <InfiniteScroll
                            // scrollableTarget="scrollableCard"
                            height={typeof cardModeSetting?.singleRowHeight === "string" ? "" : `${(pagination?.pageSize / cardModeSetting?.columnsCount || 5) * cardModeSetting?.singleRowHeight || 60}px`}
                            dataLength={dataInformations?.data?.length}
                            next={() => {
                                table.setPageIndex(pagination?.pageIndex + 1);
                                onPageChange({
                                    params: {
                                        current: pagination?.pageIndex + 2,
                                        pageSize: pagination?.pageSize,
                                        keyword: customFilterValue,
                                    },
                                    sort: transferSortAntdToShadcn({
                                        sorts: sorting,
                                    }),
                                    filter: {},
                                });
                                setPagination((pre) => {
                                    return {
                                        ...pre,
                                        pageIndex: pagination?.pageIndex + 1,
                                    }
                                })
                            }}
                            hasMore={dataInformations?.data?.length < dataInformations?.total}
                            loader={<h4> <Spinner>資料讀取中 請稍候...</Spinner></h4>}
                            endMessage={
                                <p style={{ textAlign: "center" }}>
                                    <b>已經沒有更多資料了</b>
                                </p>
                            }
                        >

                            <Row>
                                <Col span={24}>
                                    <Row gutter={[8, 8]} >
                                        {
                                            (dataInformations?.data || [])?.map((record) => {
                                                let selectedRowKey = selectedRowKeys.find((e) => true);
                                                return (<Col span={24 / cardModeSetting?.columnsCount}  >
                                                    <Row gutter={[8, 8]}>
                                                        {rowSelection?.type === "radio" &&
                                                            (<Col span={24}>
                                                                <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                    <RadioGroup
                                                                        key={record[rowKey]}
                                                                        value={!!selectedRowKey ? selectedRowKey : null}
                                                                        onValueChange={() => {
                                                                            setSelectedRowKeys([record[rowKey]]);
                                                                            setSelectedRowsInfo([record]);
                                                                        }}
                                                                    >
                                                                        <RadioGroupItem value={record[rowKey]} />
                                                                    </RadioGroup>
                                                                </label>
                                                            </Col>)
                                                        }
                                                        {rowSelection?.type === "checkbox" &&
                                                            (<Col span={24}>
                                                                <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                    <Checkbox
                                                                        checked={selectedRowKeys.includes(record[rowKey])}
                                                                        onCheckedChange={(value) => {
                                                                            let select_temp = [...selectedRowKeys];
                                                                            let select_temp_info = [...selectedRowsInfo];
                                                                            if (value) {
                                                                                select_temp.push(record[rowKey]);
                                                                                select_temp_info.push(record);
                                                                            } else {
                                                                                select_temp = select_temp.filter(
                                                                                    (element) => {
                                                                                        return element !== record[rowKey];
                                                                                    }
                                                                                );
                                                                                select_temp_info = select_temp_info.filter(
                                                                                    (element) => {
                                                                                        return element[rowKey] !== record[rowKey];
                                                                                    }
                                                                                );
                                                                            }
                                                                            let selectedRows = select_temp.map(
                                                                                (rowkeyValue) => {
                                                                                    return dataInformations?.data.find(
                                                                                        (ele) => {
                                                                                            return (
                                                                                                ele[rowKey] ===
                                                                                                rowkeyValue
                                                                                            );
                                                                                        }
                                                                                    );
                                                                                }
                                                                            );
                                                                            onOtTableSelect(record, value, selectedRows);
                                                                            setSelectedRowKeys(select_temp);
                                                                            setSelectedRowsInfo(select_temp_info);
                                                                        }}
                                                                        aria-label="Select row"
                                                                    />
                                                                    <span  > </span>
                                                                </label>
                                                            </Col>)
                                                        }
                                                        <Col span={24}
                                                        >
                                                            <Row gutter={[8, 8]} justify={'end'}>

                                                                <Col span={24}>
                                                                    {cardRender(record, {
                                                                        PatchButton: !readonly &&
                                                                            <PatchButton onClick={() => {
                                                                                setModalOpen(true);
                                                                                setAxiosMode("patch")
                                                                                form.resetFields();
                                                                                let formValues = [record]
                                                                                if (propsPatchProcess) {
                                                                                    formValues = formValues?.map(item => propsPatchProcess(item))
                                                                                }
                                                                                form.setFieldsValue({ 'recordset': formValues })
                                                                            }} />,

                                                                        DeleteButton: !readonly &&
                                                                            <DeleteButton
                                                                                onConfirm={() => {
                                                                                    const { deleteData } = (propsUseData && propsUseData({})) || { deleteData: () => { } };
                                                                                    deleteData([record])
                                                                                }}
                                                                            />
                                                                    }
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Col>)
                                            })
                                        }

                                    </Row>
                                </Col>
                            </Row>
                        </InfiniteScroll>
                    )}
                </Col>}
                {showMode === "cardPage" && <Col span={24}>
                    <Row wrap gutter={[16, 16]}>
                        <Col span={24}>
                            <Row
                                gutter={[4, 4]}
                                align={"middle"}
                                justify={"end"}
                            >
                                <Col>
                                    第{" "}
                                    {pagination.pageIndex *
                                        pagination.pageSize +
                                        1}
                                    ~
                                    {(pagination.pageIndex + 1) *
                                        pagination.pageSize <=
                                        rowCount
                                        ? (pagination.pageIndex + 1) *
                                        pagination.pageSize
                                        : rowCount}{" "}
                                    筆 / 總共 {rowCount} 筆
                                </Col>
                                <Col>
                                    <Row gutter={[2, 2]} align={"middle"} wrap={false}>
                                        <Col>每頁</Col>
                                        <Col>
                                            <Select
                                                value={pagination?.pageSize}
                                                options={[
                                                    {
                                                        label: '10',
                                                        value: 10
                                                    },
                                                    {
                                                        label: '20',
                                                        value: 20
                                                    },
                                                    {
                                                        label: '30',
                                                        value: 30
                                                    },
                                                    {
                                                        label: '50',
                                                        value: 50
                                                    },
                                                    {
                                                        label: '100',
                                                        value: 100
                                                    },

                                                ]}
                                                onChange={(value) => {
                                                    table.setPageIndex(0);
                                                    onPageChange({
                                                        params: {
                                                            current: 1,
                                                            pageSize:
                                                                value,
                                                            keyword: customFilterValue,
                                                        },
                                                        sort: transferSortAntdToShadcn({
                                                            sorts: sorting,
                                                        }),
                                                        filter: {},
                                                    });
                                                    setPagination((pre) => {
                                                        return {
                                                            ...pre,
                                                            pageIndex: 0,
                                                            pageSize: value
                                                        }
                                                    })
                                                }}
                                            /></Col>
                                        <Col>筆</Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <PagenationOt
                                        pageIndex={pagination?.pageIndex}
                                        pageCount={table.getPageCount()}
                                        onChange={(currentIndex) => {
                                            table.setPageIndex(currentIndex);
                                            onPageChange({
                                                params: {
                                                    current: currentIndex + 1,
                                                    pageSize:
                                                        pagination?.pageSize,
                                                    keyword: customFilterValue,
                                                },
                                                sort: transferSortAntdToShadcn({
                                                    sorts: sorting,
                                                }),
                                                filter: {},
                                            });
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            {loading ? (
                                <Row>
                                    <Col span={24}>
                                        <Spinner>資料讀取中 請稍候...</Spinner>
                                    </Col>
                                </Row>
                            ) : (
                                <Row>
                                    <Col span={24}>
                                        <Row gutter={[8, 8]} >
                                            {dataInformations?.data.length > 0 ?
                                                (dataInformations?.data || [])?.map((record) => {
                                                    let selectedRowKey = selectedRowKeys.find((e) => true);
                                                    return (<Col span={24 / cardModeSetting?.columnsCount}  >
                                                        <Row gutter={[8, 8]}>
                                                            {rowSelection?.type === "radio" &&
                                                                (<Col span={24}>
                                                                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                        <RadioGroup
                                                                            key={record[rowKey]}
                                                                            value={!!selectedRowKey ? selectedRowKey : null}
                                                                            onValueChange={() => {
                                                                                setSelectedRowKeys([record[rowKey]]);
                                                                                setSelectedRowsInfo([record]);
                                                                            }}
                                                                        >
                                                                            <RadioGroupItem value={record[rowKey]} />
                                                                        </RadioGroup>
                                                                    </label>
                                                                </Col>)
                                                            }
                                                            {rowSelection?.type === "checkbox" &&
                                                                (<Col span={24}>
                                                                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                        <Checkbox
                                                                            checked={selectedRowKeys.includes(record[rowKey])}
                                                                            onCheckedChange={(value) => {
                                                                                let select_temp = [...selectedRowKeys];
                                                                                let select_temp_info = [...selectedRowsInfo];
                                                                                if (value) {
                                                                                    select_temp.push(record[rowKey]);
                                                                                    select_temp_info.push(record);
                                                                                } else {
                                                                                    select_temp = select_temp.filter(
                                                                                        (element) => {
                                                                                            return element !== record[rowKey];
                                                                                        }
                                                                                    );
                                                                                    select_temp_info = select_temp_info.filter(
                                                                                        (element) => {
                                                                                            return element[rowKey] !== record[rowKey];
                                                                                        }
                                                                                    );
                                                                                }
                                                                                let selectedRows = select_temp.map(
                                                                                    (rowkeyValue) => {
                                                                                        return dataInformations?.data.find(
                                                                                            (ele) => {
                                                                                                return (
                                                                                                    ele[rowKey] ===
                                                                                                    rowkeyValue
                                                                                                );
                                                                                            }
                                                                                        );
                                                                                    }
                                                                                );
                                                                                onOtTableSelect(record, value, selectedRows);
                                                                                setSelectedRowKeys(select_temp);
                                                                                setSelectedRowsInfo(select_temp_info);
                                                                            }}
                                                                            aria-label="Select row"
                                                                        />
                                                                        <span  > </span>
                                                                    </label>
                                                                </Col>)
                                                            }
                                                            <Col span={24}
                                                            >
                                                                <Row gutter={[8, 8]} justify={'end'}>

                                                                    <Col span={24}>
                                                                        {cardRender(record, {
                                                                            PatchButton: <PatchButton onClick={() => {
                                                                                setModalOpen(true);
                                                                                setAxiosMode("patch")
                                                                                form.resetFields();
                                                                                let formValues = [record]
                                                                                if (propsPatchProcess) {
                                                                                    formValues = formValues?.map(item => propsPatchProcess(item))
                                                                                }
                                                                                form.setFieldsValue({ 'recordset': formValues })
                                                                            }} />,

                                                                            DeleteButton: <DeleteButton
                                                                                onConfirm={() => {
                                                                                    const { deleteData } = (propsUseData && propsUseData({})) || { deleteData: () => { } };
                                                                                    deleteData([record])
                                                                                }}
                                                                            />
                                                                        }
                                                                        )}
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Col>)
                                                }) :
                                                (<Col span={24} >
                                                    <Row justify="center">
                                                        <Col>
                                                            沒有資料
                                                        </Col>
                                                    </Row>
                                                </Col>)
                                            }
                                        </Row>
                                    </Col>
                                </Row>
                            )}
                        </Col>
                        <Col span={24}>
                            <Row
                                gutter={[4, 4]}
                                align={"middle"}
                                justify={"end"}
                            >
                                <Col>
                                    第{" "}
                                    {pagination.pageIndex *
                                        pagination.pageSize +
                                        1}
                                    ~
                                    {(pagination.pageIndex + 1) *
                                        pagination.pageSize <=
                                        rowCount
                                        ? (pagination.pageIndex + 1) *
                                        pagination.pageSize
                                        : rowCount}{" "}
                                    筆 / 總共 {rowCount} 筆
                                </Col>
                                <Col>
                                    <Row gutter={[2, 2]} align={"middle"} wrap={false}>
                                        <Col>每頁</Col>
                                        <Col>
                                            <Select
                                                value={pagination?.pageSize}
                                                options={[
                                                    {
                                                        label: '10',
                                                        value: 10
                                                    },
                                                    {
                                                        label: '20',
                                                        value: 20
                                                    },
                                                    {
                                                        label: '30',
                                                        value: 30
                                                    },
                                                    {
                                                        label: '50',
                                                        value: 50
                                                    },
                                                    {
                                                        label: '100',
                                                        value: 100
                                                    },

                                                ]}
                                                onChange={(value) => {
                                                    table.setPageIndex(0);
                                                    onPageChange({
                                                        params: {
                                                            current: 1,
                                                            pageSize:
                                                                value,
                                                            keyword: customFilterValue,
                                                        },
                                                        sort: transferSortAntdToShadcn({
                                                            sorts: sorting,
                                                        }),
                                                        filter: {},
                                                    });
                                                    setPagination((pre) => {
                                                        return {
                                                            ...pre,
                                                            pageIndex: 0,
                                                            pageSize: value
                                                        }
                                                    })
                                                }}
                                            /></Col>
                                        <Col>筆</Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <PagenationOt
                                        pageIndex={pagination?.pageIndex}
                                        pageCount={table.getPageCount()}
                                        onChange={(currentIndex) => {
                                            table.setPageIndex(currentIndex);
                                            onPageChange({
                                                params: {
                                                    current: currentIndex + 1,
                                                    pageSize:
                                                        pagination?.pageSize,
                                                    keyword: customFilterValue,
                                                },
                                                sort: transferSortAntdToShadcn({
                                                    sorts: sorting,
                                                }),
                                                filter: {},
                                            });
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>}
            </Row>
        );
    }
);

const ManageColumns = ({
    columns = [],
    extra_columns = [],
    set_extra_columns = () => { },
    onChange = () => { },
}) => {
    const [show, set_show] = useState(false);
    const [selected, set_selected] = useState(extra_columns);
    return (
        <>
            <MultipleSelector
                value={selected}
                style={{
                    minWidth: "200px",
                }}
                onChange={(e) => {
                    set_selected((pre) => {
                        return e;
                    });
                    onChange(e);
                }}
                hidden={!show}
                options={extra_columns}
                placeholder="請輸入"
                creatable
                emptyIndicator={
                    <p className="text-center text-lg leading-10 text-gray-600 dark:text-gray-400">
                        沒有選項
                    </p>
                }
            />
        </>
    );
};
const DemoProTableOt = () => {
    const actionRef = useRef(null);
    const [permissionGroup, setPermissionGroup] = useState([{ hi: 123 }])
    const columns = [
        {
            title: "項次",
            dataIndex: "key",
            key: "key",
            canFilter: false,
        },
        {
            title: "權限名稱",
            dataIndex: "permission_name",
            key: "permission_name",
            canFilter: true,
            filterType: "search"

        },
        {
            title: "分類名稱",
            key: "permission_group_name",
            dataIndex: "permission_group_name",
            canFilter: true,
            filterType: "search",
            filterInitialArray: permissionGroup,
        },
        // {
        //     title: "分類",
        //     dataIndex: "news_type_name",
        //     key: "news_type_name",
        //     canFilter: false,
        // },
        // {
        //     title: "標題",
        //     dataIndex: "news_title",
        //     key: "news_title",
        //     canFilter: true, 
        //     filterType: "search"

        // },
        // {
        //     title: "公開狀態",
        //     key: "open_status",
        //     dataIndex: "news_time",
        //     disabled: true,
        //     render: (text, record, index) => {
        //         let currentTime = dayjs();
        //         let news_time = dayjs(text, "YYYY-MM-DD HH:mm:ss");
        //         let isAnnounce = news_time.isBefore(currentTime);
        //         if (isAnnounce) {
        //             return <div>已發佈</div>;
        //         } else {
        //             return <div>未發佈</div>;
        //         }
        //     },
        // },
        // {
        //     title: "發佈者",
        //     dataIndex: "staff_name",
        //     key: "staff_name",
        // },
        // {
        //     title: "發佈時間",
        //     key: "news_time",
        //     dataIndex: "news_time",
        // },
        // {
        //     title: "結束時間",
        //     key: "announce_time_end",
        //     dataIndex: "announce_time_end",
        // },
        // {
        //     title: "重要程度",
        //     dataIndex: "news_weight_type_name",
        //     key: "news_weight_type_name",
        // },
        // {
        //     title: "點擊率",
        //     dataIndex: "click_num",
        //     key: "click_num",
        // },
        // {
        //     title: "消息連結",
        //     dataIndex: "news_id",
        //     key: "news_id",
        //     disabled: true,
        //     sorter: false,
        //     render: (text, record, index) => {
        //         return (
        //             <Button
        //                 type="primary"
        //                 style={{
        //                     color: "#fff",
        //                     backgroundColor: "#A6A6A6",
        //                 }}
        //                 onClick={() => { }}
        //             >
        //                 點我前往
        //             </Button>
        //         );
        //     },
        // },
        // {
        //     title: "操作",
        //     valueType: "option",
        //     key: "option",
        //     fixed: "right",
        //     sorter: false,
        //     disabled: true,
        //     render: (text, record, _index) => {
        //         return (
        //             <Row gutter={[8, 8]}>
        //                 <Col>
        //                     <Button
        //                         type="link"
        //                         style={{
        //                             color: "#2BC17B",
        //                         }}
        //                         onClick={() => {
        //                             // handleEditRow(record)
        //                             console.log(record);
        //                         }}
        //                     >
        //                         修改
        //                     </Button>
        //                 </Col>
        //                 <Col>
        //                     <Button type="link" danger>
        //                         刪除
        //                     </Button>
        //                 </Col>
        //             </Row>
        //         );
        //     },
        // },
    ];
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [extra_columns, set_extra_columns] = useState([]);

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            console.log({
                selected,
                selectedRows,
                changeRows,
            });
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.news_id);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.news_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record.news_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record.news_id
                );
                selectRow = selectRow.filter(
                    (row) => row.news_id !== record.news_id
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const onFinish = ({ axiosMode, status, values }) => {
        // if (status === "success") {
        //     if (axiosMode === "post") {
        //         message.success("新增成功")
        //         actionRef.current.reloadAndRest();
        //     }
        //     else if (axiosMode === "patch") {
        //         message.success("修改成功")
        //         actionRef.current.reloadAndRest();
        //     }
        //     else if (axiosMode === "delete") {
        //         message.success("刪除成功")
        //         actionRef.current.reloadAndRest();
        //         setSelectedRowKeys([])
        //         setSelectedRowsInfo([])
        //     }
        //     setModalLoading(false)
        //     setModalOpen(false)
        // }
        // else if (status === "error") {
        //     if (axiosMode === "post") {
        //         message.error("新增失敗")
        //         actionRef.current.reloadAndRest();
        //     }
        //     else if (axiosMode === "patch") {
        //         message.error("修改失敗")
        //         actionRef.current.reloadAndRest();
        //     }
        //     else if (axiosMode === "delete") {
        //         message.error("刪除失敗")
        //         actionRef.current.reloadAndRest();
        //     }
        //     setModalLoading(false)
        //     setModalOpen(false)
        // }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    };
    const { PermissionGroupData, getPermissionGroupData, getPermissionData, getNewsData, postNewsData, patchNewsData, deleteNewsData } =
        useNews({
            onFinish,
            onBefore,
        });
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn,
    } = useProTableOt({
        columns,
    });
    useEffect(() => {
        setPermissionGroup(PermissionGroupData)
    }, [PermissionGroupData])
    useEffect(() => {
        checkAll();
        getPermissionGroupData()
    }, []);
    return (
        <Row>
            <Col span={24}>
                <ProTableOt
                    actionRef={actionRef}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    headerTitle={<>headerTitle</>}
                    rowKey={"news_id"}
                    request={async (params = {}, sort, filter) => {
                        // setAxiosMode("get")
                        let newParams = {};
                        let order = setOrders(sort);
                        newParams = {
                            ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                            ...filter,
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        // setPageSize(params?.pageSize ?? 20)

                        return getPermissionData({
                            ...newParams,
                        });
                    }}
                    toolBarRender={() => {
                        return [
                            <Button
                                onClick={() => {
                                    actionRef.current.reload();
                                }}
                            >
                                重整按鈕
                            </Button>,
                        ];
                    }}
                    rowSelection={{
                        type: "checkbox",
                        selectedRowKeys: selectedRowKeys,
                        ...rowSelection,
                    }}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    manage_columns={true}
                />
            </Col>
        </Row>
    );
};
const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce(
        (all, [key, value]) =>
            value === "" ? { ...all } : { ...all, [key]: value },
        {}
    );
};
export default ProTableOt;
export { DemoProTableOt };

const Card = ({ column = {}, index = 0, moveCard = () => { } }) => {
    const id = column?.id;
    const ref = useRef(null);
    const [{ handlerId }, drop] = useDrop({
        accept: "card",
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            };
        },
        drop(item) {
            moveCard(item.index);
        },
    });
    const [{ isDragging }, drag] = useDrag({
        type: "card",
        item: () => {
            return { id, index };
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const { getData: getCustomPageSetting, postData: postCustomPageSetting, ResponseData: customPageSettingData } = useCRUDController({
        apiRoute: '/utility/custom_page_setting'
    })

    const opacity = isDragging ? 0 : 1;
    drag(drop(ref));
    return (
        <>
            <DropdownMenuCheckboxItem
                key={column.id}
                className="capitalize"
                checked={column.getIsVisible()}
                onCheckedChange={(value) => {
                    column.toggleVisibility(!!value)
                    const storedSettings = JSON.parse(localStorage.getItem(`ot-table-setting`)) || {};
                    localStorage.setItem(`ot-table-setting`, JSON.stringify({
                        ...storedSettings,
                        [column?.id]: {
                            ...storedSettings?.[column?.id],
                            show: !!value
                        }
                    }));
                    postCustomPageSetting([{
                        page_name: window.location.pathname,
                        custom_setting: localStorage.getItem(`ot-table-setting`)
                    }])
                }}
                moveCard={moveCard}
                data-handler-id={handlerId}
                style={{ opacity }}
                ref={ref}
            >
                <Row
                    style={{
                        cursor: "grab"
                    }}
                    align={"middle"} justify="space-around">
                    <Col>
                        <EllipsisVertical size={12} />
                    </Col>
                    <Col>
                        {column.columnDef?.title}
                    </Col>
                </Row>
            </DropdownMenuCheckboxItem>
        </>
    );
};
const Manage_columns = ({
    columns = [],
    extra_columns = [],
    set_extra_columns = () => { },
    onChange = () => { },
}) => {
    const [show, set_show] = useState(false);
    const [selected, set_selected] = useState(extra_columns);
    return (
        <>
            <MultipleSelector
                value={selected}
                style={{
                    minWidth: "200px",
                }}
                onChange={(e) => {
                    set_selected((pre) => {
                        return e;
                    });
                    onChange(e);
                }}
                hidden={!show}
                options={extra_columns}
                placeholder="請輸入"
                creatable
                emptyIndicator={
                    <p className="text-center text-lg leading-10 text-gray-600 dark:text-gray-400">
                        沒有選項
                    </p>
                }
            />
        </>
    );
};

